<template>

  <Modal v-if="value" :value="value" :with-footer="false" @input="close">
    <p slot="header">{{ webhook.id ? 'Editar webhook' : 'Novo webhook' }}</p>

    <Form
      :webhook="webhook"
      :available-events="availableEvents"
      @cancel="close"
      @saved="$emit('saved')"
      @created="$emit('created', $event)"
    />

  </Modal>

</template>

<script>
  import Form from '@/components/webhooks/Form'
  import Modal from '@/components/shares/specialTag/Modal'

  export default {
    components: { Form, Modal },
    methods: {
      close() {
        this.$emit('input', false)
      }
    },
    name: 'WebhookModal',
    props: {
      availableEvents: { default: () => [], type: Array },
      value: { default: false, type: Boolean },
      webhook: { default: () => ({}), type: Object }
    }
  }
</script>

<style scoped>
</style>
